$(function(){
    // observer for header height
    const header = document.querySelector('#main-header');

    const setHeightVairable = (height = 0) => {
        document.querySelector('html').style.setProperty('--header-height', height + "px");
    }
    
    let prevHeight = 0;
    
    const resizeObserver = new ResizeObserver(entries => {
        for ( const entry of entries ) {

            const height = entry.borderBoxSize?.[0].blockSize;

            if ( typeof height === 'number' && height !== prevHeight ) {
                prevHeight = height;
                setHeightVairable( height );
            }

        }
    });

    resizeObserver.observe( header );

    // mobile menu
    $('.navbar-toggler').on('click', function(){
        $('body').toggleClass('mobile-nav-active');

        $('#main-header a').on('click', function(){
            $('body').removeClass('mobile-nav-active');
        });
    });
});
